import React from "react";

const MissionVision = () => {
  return (
    <>
      <section id="about" className="relative bg-black text-white px-6 py-32 overflow-hidden">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold mb-6 text-center">About Us</h2>
          <p className="text-gray-400 text-lg leading-relaxed text-center mb-12">
            At Pentomino Solutions, we are more than just a tech company — we’re a team of innovators, thinkers, and builders dedicated to crafting transformative digital experiences. From mobile apps to custom enterprise software, we deliver solutions that empower growth and streamline operations. <br /><br />
            Our approach is rooted in collaboration, agility, and a deep understanding of technology's evolving role in modern business. We believe in building partnerships that go beyond the transactional — ones where trust, innovation, and impact drive lasting results.
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gray-900 p-6 rounded-xl shadow-md hover:shadow-green-400 hover:-translate-y-2 transition-all">
              <h3 className="text-xl font-semibold mb-4 text-green-400">Our Mission</h3>
              <p className="text-gray-400">
                To provide reliable, innovative solutions that deliver value, efficiency, and long-term impact to our clients and partners. We aim to simplify complexity and turn ideas into impactful, scalable products.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-xl shadow-md hover:shadow-green-400 hover:-translate-y-2 transition-all">
              <h3 className="text-xl font-semibold mb-4 text-green-400">Our Vision</h3>
              <p className="text-gray-400">
                To be a global leader in IT services by constantly adapting, evolving, and pushing boundaries in digital innovation. We envision a world where technology empowers every business to unlock its full potential.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-xl shadow-md hover:shadow-green-400 hover:-translate-y-2 transition-all">
              <h3 className="text-xl font-semibold mb-4 text-green-400">Why Choose Us?</h3>
              <p className="text-gray-400">
                Our agile mindset, commitment to quality, and customer-first approach ensure we deliver not just solutions — but success stories. We pride ourselves on staying ahead of the curve, always learning, and always delivering.
              </p>
            </div>
          </div>
        </div>

        {/* Decorative Dots */}
        <div className="absolute bottom-10 left-10 w-2 h-2 bg-blue-500 rounded-full"></div>
        <div className="absolute bottom-16 left-1/4 w-2 h-2 bg-orange-500 rounded-full"></div>
        <div className="absolute top-10 right-10 w-2 h-2 bg-green-500 rounded-full"></div>
      </section>
    </>
  );
};

export default MissionVision;
